import { render, staticRenderFns } from "./ProdutoNewModal.vue?vue&type=template&id=ab41f9de&scoped=true"
import script from "./ProdutoNewModal.vue?vue&type=script&lang=js"
export * from "./ProdutoNewModal.vue?vue&type=script&lang=js"
import style0 from "./ProdutoNewModal.vue?vue&type=style&index=0&id=ab41f9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab41f9de",
  null
  
)

export default component.exports